import React, { useContext } from "react";
import { Document, Page, View, Text, StyleSheet, Image } from "@react-pdf/renderer";
import moment from "moment";
import 'moment/locale/es-mx';
import total_protect from "../../src/assets/img/TOTAL PROTECT.png";
import { AuthContext } from "../context/authContext/authContext";


export const DocuPDFEventoSeguridad = ({ registroSeguridadEventos, unidadEventSeguridad }) => {

    const styles = StyleSheet.create({
        text: {
            // color: "red",
            fontWeight: "bold",
            padding: "5px",
            fontSize: "10px"
        },
        fecha: {
            fontWeight: "bold",
            padding: "0 5px",
            fontSize: "8px",
            textTransform: "uppercase",
        },
        bold: { fontWeight: 'bold' },
        col30: {
            width: "30%",
            height: "150px",
            margin: "10px",
        },
        col50: {
            width: "45%",
            height: "auto",
            backgroundColor: "#ccc",
            margin: "10px"
        },
        col100: {
            width: "100%",
            height: "100%",
            border: "5px solid #fff",
            background: "white",
        },
        titulo: {
            fontSize: "10px",
            textAlign: "center",
            fontWeight: "bolder"
        },
        text_align_left: {
            textAlign: "right"
        },
        p5: {
            padding: "5px",
        },
        position_absolute: {
            position: "absolute",
        },
        position_relative: {
            position: "relative",
        },
        caja2: {
            display: "table-cell",
            left: "33%",
            position: "absolute"
        },
        caja3: {
            display: "table-cell",
            left: "66%",
            position: "absolute"

        },
        contenedor1: {
            borderBottom: "1px solid #ccc"
        },
        table: {
            display: "table",
            width: "auto",
            border: "1px solid #ccc",
            borderWidth: 0,
            borderRightWidth: 0,
            borderBottomWidth: 1
        },
        tableRow: {
            margin: "auto",
            flexDirection: "row"
        },
        tableCol: {
            width: "16.7%",
            border: "1px solid #ccc",
            borderWidth: 0,
            borderLeftWidth: 0,
            borderTopWidth: 1,
            padding: "2px"
        },
        tableColEncabezado: {
            width: "16.7%",
            border: "1px solid #ccc",
            borderWidth: 0,
            borderLeftWidth: 0,
            borderTopWidth: 0,
            padding: "2px",
            backgroundColor: "#E9E9E9"
        },
        tableCell: {
            margin: "auto",
            margin: 8,
            fontSize: 8
        },
        tabla_eventos: {
            marginTop: "20px"
        },
        ifonTabla: {
            color: "#4D4A4A"
        }
    })

    return (
        <Document size="A4" title="EVENTOS DE SEGURIDAD">

            {
                registroSeguridadEventos.map((evt, index) => {

                    if (unidadEventSeguridad && evt.evento_seguridad_id === unidadEventSeguridad) {
                        return (
                            <>
                                <Page key={index}>
                                    <View style={[styles.position_relative, styles.col100]}>
                                        <View style={styles.p5}>
                                            <Image src={total_protect} alt="total protect" style={{ maxWidth: "130px", maxHeight: "70px" }} />
                                            <Text style={styles.titulo} >
                                                UNIDAD: {
                                                    evt.tipo_unidad_id === 1 ?
                                                        evt.viaje.unidad.unidad_numero + "    " :
                                                        evt.unidad_vin + "    "
                                                }
                                                FOLIO: {evt.folio}
                                            </Text>

                                        </View>
                                        <View style={[styles.position_relative, styles.contenedor1]}>
                                            <View style={{ width: "25%", height: "150px", margin: "10px", padding: "5px" }}>
                                                <Text style={styles.text}>
                                                    Fecha de registro:
                                                </Text>
                                                <Text style={styles.fecha}>
                                                    {moment(evt.createdAt).format("lll")}
                                                </Text>
                                                <Text style={styles.text}>
                                                    Placas: {
                                                        evt.tipo_unidad_id === 1 ?
                                                            evt.viaje.unidad.unidad_placas :
                                                            evt.unidad.unidad_placas
                                                    }
                                                </Text>

                                                <Text style={styles.text}>
                                                    Serie: {
                                                        evt.tipo_unidad_id === 1 ?
                                                            evt.viaje.unidad.unidad_vin :
                                                            evt.unidad.unidad_vin
                                                    }
                                                </Text>

                                                <Text style={styles.text}>
                                                    Marca: {
                                                        evt.tipo_unidad_id === 1 ?
                                                            evt.viaje.unidad.unidad_marca :
                                                            evt.unidad.unidad_marca
                                                    }
                                                </Text>

                                                <Text style={styles.text}>
                                                    SubMarca: {
                                                        evt.tipo_unidad_id === 1 ?
                                                            evt.viaje.unidad.unidad_modelo :
                                                            ""
                                                    }
                                                </Text>

                                                <Text style={styles.text}>
                                                    Color: {
                                                        evt.tipo_unidad_id === 1 ?
                                                            evt.viaje.unidad.unidad_color :
                                                            evt.unidad.unidad_color
                                                    }
                                                </Text>
                                                {
                                                    evt.tipo_unidad_id === 1 ? (
                                                        <>
                                                            <Text style={styles.text}>
                                                                Negocio: {evt.viaje.unidad.negocio.negocio_nombre}
                                                            </Text>

                                                            <Text style={styles.text}>
                                                                Cedis: {evt.viaje.unidad.cedi.nombre_cedis}
                                                            </Text>
                                                        </>
                                                    ) : ""
                                                }

                                            </View>
                                            <View style={[styles.p5, styles.col30, styles.caja2]}>
                                                <Text style={styles.text}>
                                                    Monitorista: {evt.usuario.name}
                                                </Text>
                                                {
                                                    evt.tipo_unidad_id === 1 ? (
                                                        <>
                                                            <Text style={styles.text}>
                                                                Operador: {evt.viaje.chofer.nombre_completo}
                                                            </Text>
                                                            <Text style={styles.text}>
                                                                Número de teléfono: {evt.viaje.chofer.telefono}
                                                            </Text>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Text style={styles.text}>
                                                                Gestor-Usuario: 
                                                            </Text>
                                                            <Text style={styles.text}>
                                                                Número de teléfono:
                                                            </Text>
                                                        </>
                                                    )
                                                }


                                                {/* <Text style={styles.text}>
                                                    Tripulación: Manuel Antonio Flores Cerros
                                                </Text>
                                                <Text style={styles.text}>
                                                    Número de teléfono: 74766554982
                                                </Text> */}
                                                <Text style={styles.text}>
                                                    Municipio: {evt.municipio.municipio}
                                                </Text>
                                                <Text style={styles.text}>
                                                    Estado: {evt.estado.entidad_federativa}
                                                </Text>
                                            </View>
                                            <View style={{ width: "30%", height: "150px", margin: "10px", padding: "5px", display: "table-cell", left: "66%", position: "absolute" }}>
                                                <Text style={styles.text}>
                                                    Carpeta de investigación: {evt.carpeta_investigacion}
                                                </Text>
                                                <Text style={styles.text}>
                                                    Chapas de seguridad: {evt.chapa_seguridad}
                                                </Text>
                                                <Text style={styles.text}>
                                                    Predenuncia: {evt.predenuncia}
                                                </Text>
                                                <Text style={styles.text}>
                                                    Modus operandi: {evt.modus_operandi}
                                                </Text>
                                                <Text style={styles.text}>
                                                    AS3: {evt.activacion_as3}
                                                </Text>
                                                <Text style={styles.text}>
                                                    CCTV: {evt.cctv}
                                                </Text>
                                            </View>
                                            <View style={{ flexDirection: "row" }}>
                                                <View style={{ width: "50%", margin: "0 10px" }}>
                                                    <Text style={styles.text}>
                                                        Coordenadas del lugar de evento:
                                                    </Text>
                                                    <Text style={styles.text}>
                                                        {evt.coordenadas_inicio}
                                                    </Text>
                                                </View>
                                                <View style={{ width: "50%", margin: "0 10px" }}>
                                                    <Text style={styles.text}>
                                                        Vialidad:
                                                    </Text>
                                                    <Text style={styles.text}>
                                                        {evt.vialidad}
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={styles.tabla_eventos} key={index}>
                                            <View style={styles.table}>
                                                <View style={styles.tableRow}>
                                                    <View style={styles.tableColEncabezado}>
                                                        <Text style={styles.tableCell}>ESTATUS</Text>
                                                    </View>
                                                    <View style={styles.tableColEncabezado}>
                                                        <Text style={styles.tableCell}>FECHA ACTUALIZACIÓN</Text>
                                                    </View>
                                                    <View style={styles.tableColEncabezado}>
                                                        <Text style={styles.tableCell}>TIPOS DE APOYO</Text>
                                                    </View>
                                                    <View style={styles.tableColEncabezado}>
                                                        <Text style={styles.tableCell}>LUGAR REMITIDO</Text>
                                                    </View>
                                                    <View style={styles.tableColEncabezado}>
                                                        <Text style={styles.tableCell}>COORDENADAS</Text>
                                                    </View>
                                                    <View style={styles.tableColEncabezado}>
                                                        <Text style={styles.tableCell}>OBSERVACIONES</Text>
                                                    </View>
                                                </View>
                                                {
                                                    evt.registro_evento_seguridads.map((seguimiento, index) => {

                                                        return (
                                                            <>
                                                                <View style={styles.tableRow} key={index}>
                                                                    <View style={styles.tableCol}>
                                                                        <Text style={[styles.tableCell, styles.ifonTabla]}>
                                                                            {seguimiento.estatus_evento.estatus_evento}
                                                                        </Text>
                                                                    </View>
                                                                    <View style={styles.tableCol}>
                                                                        <Text style={[styles.tableCell, styles.ifonTabla]}>
                                                                            {moment(seguimiento.updatedAt).format("lll")}
                                                                        </Text>
                                                                    </View>
                                                                    <View style={styles.tableCol} key={index}>
                                                                        <Text style={[styles.tableCell, styles.ifonTabla]}>
                                                                            {
                                                                                seguimiento.tipo_apoyo_riesgos.map((apoyo, index) => {
                                                                                    return (
                                                                                        <>
                                                                                            {apoyo.apoyo_tipo.apoyo_tipo + ", "}
                                                                                        </>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </Text>
                                                                    </View>

                                                                    <View style={styles.tableCol}>
                                                                        <Text style={[styles.tableCell, styles.ifonTabla]}>
                                                                            {seguimiento.lugar}
                                                                        </Text>
                                                                    </View>
                                                                    <View style={styles.tableCol}>
                                                                        <Text style={[styles.tableCell, styles.ifonTabla]}>
                                                                            {seguimiento.coordenadas}
                                                                        </Text>
                                                                    </View>
                                                                    <View style={styles.tableCol}>
                                                                        <Text style={[styles.tableCell, styles.ifonTabla]}>
                                                                            {seguimiento.observaciones}
                                                                        </Text>
                                                                    </View>
                                                                </View>
                                                            </>
                                                        )
                                                    })
                                                }

                                            </View>
                                        </View>
                                    </View>
                                </Page>
                            </>
                        )
                    }
                })
            }
        </Document>
    );
};
